import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const AI_OBSERVABILITY_PATH = '/admin/ai-observability';

export const AiObservabilityLegacyRedirect: React.FC = () => {
    const location = useLocation();

    return (
        <Navigate
            replace
            to={{
                pathname: AI_OBSERVABILITY_PATH,
                search: location.search,
                hash: location.hash,
            }}
        />
    );
};
